import { useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from 'src/functions/localStorageHandler';

interface IPricingQuizModalController {
  displayPricingQuiz: (show: boolean) => () => void;
  quizIsOpen: boolean;
  skipIntro: boolean;
}

const MODAL_SHOWN_KEY = 'pricingQuiz:shown';
export const QUIZ_IFRAME_INTERACTION_STORAGE_KEY = 'pricingQuiz:interacted';
export const QUIZ_SKIPPING_INTRO_ID = '66b136f22085c70015c1177d';
export const QUIZ_WITH_INTRO_ID = '67215ba1c666610015984b3d';

const usePricingQuizModalController = (autoOpen = true): IPricingQuizModalController => {
  const [quizIsOpen, setQuizIsOpen] = useState<boolean>(false);
  const [skipIntro, setSkipIntro] = useState<boolean>(false);

  const shouldShowModal = () => {
    const hasInteracted = getLocalStorage(QUIZ_IFRAME_INTERACTION_STORAGE_KEY);

    if (hasInteracted === 'true') return false;

    const lastTimeShown = getLocalStorage(MODAL_SHOWN_KEY);

    if (!lastTimeShown) return true;

    const timeDifferenceInDays = (new Date().getTime() - parseInt(lastTimeShown, 10)) / (1000 * 60 * 60 * 24);

    return timeDifferenceInDays >= 7;
  };

  useEffect(() => {
    if (quizIsOpen || !shouldShowModal() || !autoOpen) return;

    const timeout = setTimeout(() => {
      setModalValue(true);
      setSkipIntro(false);
    }, 20000);

    return () => clearTimeout(timeout);
  }, [quizIsOpen, autoOpen]);

  const setModalValue = (show: boolean) => {
    if (show) {
      setLocalStorage(MODAL_SHOWN_KEY, new Date().getTime().toString());
    }

    setQuizIsOpen(show);
  };

  const displayPricingQuiz = (show: boolean) => () => {
    setModalValue(show);
    setSkipIntro(true);
  };

  return {
    displayPricingQuiz,
    quizIsOpen,
    skipIntro,
  };
};

export default usePricingQuizModalController;
